import TempInspection from './TempInspection';

export default TempInspection;
